<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success"
                :loading="buttonLoading"
                v-bind="attrs"
                v-on="on"
                ><v-icon>cloud_download</v-icon>Export</v-btn
              >
            </template>

            <v-list>
              <v-list-tile @click="exportAll()">
                <v-list-tile-content>
                  <v-list-tile-title>EXPORT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4>
              <v-text-field
                name="brandName"
                label="Brand Name"
                v-model="queryParams.brandName"
                type="text"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-text-field
                name="categoryName"
                label="Category Name"
                v-model="queryParams.categoryName"
                type="text"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-autocomplete
                :items="warehouseList"
                label="Choose Warehouse..."
                item-text="name"
                menu-props="auto"
                item-value="id"
                :hide-no-data="true"
                v-model="queryParams.warehouseId"
                :disabled="checkUserWarehouse() ? true : false"
              ></v-autocomplete>
            </v-flex>
            <v-flex sm4>
              <v-select
                label="Type"
                :items="planTypeList"
                v-model="queryParams.type"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex sm4>
              <v-autocomplete
                v-model="queryParams.productIds"
                :items="selectedProductList"
                label="Current Asset"
                @click="showProducts()"
                item-text="name"
                item-value="id"
                multiple
                menu-props="auto"
                autocomplete
              ></v-autocomplete>
            </v-flex>
            <v-flex sm4>
              <v-autocomplete
                v-model="queryParams.assetIds"
                :items="selectedAssetList"
                label="Fixed Asset"
                @click="showAssetDialog = !showAssetDialog"
                item-text="assetName"
                item-value="id"
                multiple
                menu-props="auto"
                autocomplete
              ></v-autocomplete>
            </v-flex>
            <v-flex sm4>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>

      <!--summary-->
      <v-flex xs12>
        <v-card>
          <v-card-title class="blue darken-3">
            <span class="headline white--text">Summary</span>
            <v-spacer></v-spacer>
            <v-icon @click="show = !show" class="white--text">{{
              show ? "keyboard_arrow_up" : "keyboard_arrow_down"
            }}</v-icon>
          </v-card-title>
          <v-card-text class="font-weight-bold" v-show="show">
            <div>
              <span>Total Plan Qty:</span>
              <v-chip>
                <span>{{ totalPlanQty | decFormat(6) }}</span>
              </v-chip>
              <span>Total Purchase Order Qty:</span>
              <v-chip>
                <span>{{ totalPOQty | decFormat(6) }}</span>
              </v-chip>
              <span>Total Remaining Qty:</span>
              <v-chip>
                <span>{{ totalRemainingQty | decFormat(6) }}</span>
              </v-chip>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>

      <!--list-->
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="procurementPlanReportList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            :must-sort="true"
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.productCode }}</td>
              <td>{{ props.item.productName }}</td>
              <td>{{ props.item.assetCode }}</td>
              <td>{{ props.item.assetName }}</td>
              <td>{{ props.item.factorUnitName }}</td>
              <td style="text-align: right">
                {{ props.item.planQty | decFormat(6) }}
              </td>
              <td style="text-align: right">
                {{ props.item.poQty | decFormat(6) }}
              </td>
              <td style="text-align: right">
                {{ props.item.remainingQty | decFormat(6) }}
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- Product list dialog -->
    <v-dialog v-model="showProductListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="code"
                label="Code"
                type="text"
                class="mr-1"
                v-model="productQueryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="name"
                label="Name"
                type="text"
                class="mr-1"
                v-model="productQueryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="brandName"
                label="Brand"
                type="text"
                class="mr-1"
                v-model="productQueryParams.brandName"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="categoryName"
                label="Category"
                type="text"
                class="mr-1"
                v-model="productQueryParams.categoryName"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="productGroupName"
                label="Product Group"
                type="text"
                class="mr-1"
                v-model="productQueryParams.productGroupName"
              ></v-text-field>
            </v-flex>
            <v-flex sm2>
              <v-btn outline color="primary" @click="onSearchProduct">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!-- Product List Section -->
          <v-flex xs12 class="mt-1">
            <v-card>
              <v-data-table
                v-model="selectedProductList"
                :headers="productHeaders"
                :items="productList"
                select-all
                class="elevation-1"
                :loading="showProductListLoading"
                :total-items="productTotalRows"
                :rows-per-page-items="rowsPerPageItems"
                :pagination.sync="productPagination"
                :must-sort="true"
              >
                <template slot="headers" slot-scope="props">
                  <tr>
                    <th>
                      <v-checkbox
                        primary
                        hide-details
                        @click.native="toggleAllProduct"
                        :input-value="props.all"
                        :indeterminate="props.indeterminate"
                      ></v-checkbox>
                    </th>
                    <th v-for="header in props.headers" :key="header.text">
                      {{ header.text }}
                    </th>
                  </tr>
                </template>
                <template slot="items" slot-scope="props">
                  <td>
                    <v-checkbox
                      primary
                      hide-details
                      :input-value="props.selected"
                      :value="props.item"
                      :indeterminate="props.indeterminate"
                      v-model="selectedProductList"
                      multiple
                    ></v-checkbox>
                  </td>
                  <td>
                    <a>{{ props.item.code }}</a>
                  </td>
                  <td>{{ props.item.name }}</td>
                  <td>{{ props.item.brand.name }}</td>
                  <td>{{ props.item.category.name }}</td>
                  <td v-if="props.item.productGroup">
                    {{ props.item.productGroup.name }}
                  </td>
                  <td v-else></td>
                  <td>{{ props.item.description }}</td>
                  <td>
                    <v-icon
                      v-if="props.item.status == 'ACTIVE'"
                      medium
                      color="green"
                      >check_circle</v-icon
                    >
                    <v-icon v-else medium color="red">cancel</v-icon>
                  </td>
                </template>
              </v-data-table>
              <div class="text-xs-right">
                <v-btn color="primary" @click="setProduct">Ok</v-btn>
              </div>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!--asset list dialog-->
    <multi-select-asset-dialog
      :showDialog="showAssetDialog"
      :params="{ statusList: ['DRAFT', 'CONFIRM'] }"
      @close="closeAssetDialog"
    ></multi-select-asset-dialog>
  </v-container>
</template>

<script>
import { commonService } from "../../services/common-service";
import { productService } from "../../services/product-service";
import { warehouseService } from "../../services/warehouse-service";
import { procurementPlanAssetReportService } from "../../services/procurement-plan-asset-report-service";
import MultiSelectAssetDialog from "../dialogs/MultiSelectAssetDialog.vue";

export default {
  name: "ProcurementPlanAssetReport",
  components: { MultiSelectAssetDialog },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    showProductListLoading: false,
    showProductListDialog: false,
    showAssetDialog: false,
    showFilters: false,
    show: false,
    breadcrumbs: [
      {
        text: "Asset Management",
        disabled: true,
      },
      {
        text: "Procurement Plan Report(Asset)",
        disabled: true,
      },
    ],
    queryParams: {
      fromDate: commonService.formatDate(
        new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        "YYYY-MM-DD"
      ),
      toDate: commonService.formatDate(
        new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
        "YYYY-MM-DD"
      ),
      productIds: [],
      assetIds: [],
      type: "",
      warehouseId: "",
      brandName: "",
      categoryName: "",
    },
    productQueryParams: {
      name: "",
      code: "",
      status: "ACTIVE",
      brandName: "",
      categoryName: "",
      productGroupName: "",
    },
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "",
      totalItems: 0,
    },
    productPagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: "code",
      totalItems: 0,
    },
    statusList: [
      { label: "--- ALL ---", value: "" },
      { label: "Active", value: "ACTIVE" },
      { label: "Inactive", value: "INACTIVE" },
    ],
    headers: [
      { text: "Product Code", align: "left", value: "p.code", sortable: false },
      { text: "Product Name", value: "p.name", sortable: false },
      { text: "Fixed Asset Code", value: "s.code", sortable: false },
      {
        text: "Fixed Asset Name",
        align: "left",
        value: "s.asset_name",
        sortable: false,
      },
      { text: "Unit", sortable: false },
      { text: "Plan Qty", sortable: false },
      { text: "Purchase Order Qty", sortable: false },
      { text: "Remaining Qty", sortable: false },
    ],
    productHeaders: [
      { text: "Code", value: "code" },
      { text: "Name", value: "name" },
      { text: "Brand", value: "brand.name" },
      { text: "Category", value: "category.name" },
      { text: "Product Group", value: "productGroup.name" },
      { text: "Description", value: "description" },
      { text: "Status", sortable: false },
    ],
    planTypeList: [
      { label: "---ALL---", value: "" },
      { label: "Current_Asset", value: "Current_Asset" },
      { label: "Fixed_Asset", value: "Fixed_Asset" },
    ],
    rowsPerPageItems: [25, 50, 100],
    totalRows: 0,
    productTotalRows: 0,
    buttonLoading: false,
    selectedProductList: [],
    selectedAssetList: [],
    productList: [],
    warehouseList: [],
    procurementPlanReportList: [],
    totalPlanQty: 0,
    totalPOQty: 0,
    totalReturnQty: 0,
    totalRemainingQty: 0,
  }),
  watch: {
    pagination: {
      handler() {
        this.getProcurementPlanAssetReport();
      },
      deep: true,
    },
    productPagination: {
      handler() {
        this.getProductList();
      },
      deep: true,
    },
  },
  created() {
    this.queryParams.warehouseId = this.checkUserWarehouse();

    //for deep linking
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.$route.query.warehouseId) {
      this.queryParams.warehouseId = this.$route.query.warehouseId;
    }
    if (this.$route.query.brandName) {
      this.queryParams.brandName = this.$route.query.brandName;
    }
    if (this.$route.query.categoryName) {
      this.queryParams.categoryName = this.$route.query.categoryName;
    }
    if (this.$route.query.type) {
      this.queryParams.type = this.$route.query.type;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.getAllWarehouse();
  },
  methods: {
    checkUserWarehouse() {
      if (
        this.user.roleName == "BRANCH_ADMIN" ||
        this.user.roleName == "PROCUREMENT_MANAGER"
      ) {
        return this.user.warehouseId;
      }if (
        this.user.roleName == "ASSET_MANAGER"
      ) {
        return this.user.shop.warehouseId;
      } else {
        return "";
      }
    },
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "procurement-plan-asset-report",
        query: this.queryParams,
      });
      this.getProcurementPlanAssetReport();
    },
    getAllWarehouse() {
      warehouseService
        .getAllWarehouse()
        .then((res) => {
          this.warehouseList = res.data;
          this.warehouseList.unshift({ id: "", name: "----All----" });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    showProducts() {
      // Clean query params
      this.productQueryParams.code = "";
      this.productQueryParams.name = "";
      this.productQueryParams.brandName = "";
      this.productQueryParams.categoryName = "";
      this.productQueryParams.productGroupName = "";
      this.selectedProductList = [];
      this.queryParams.productIds = [];
      this.getProductList().then(
        (this.showProductListDialog = !this.showProductListDialog)
      );
    },
    setProduct() {
      if (this.selectedProductList.length) {
        this.queryParams.productIds = [];
        this.selectedProductList.forEach((element) => {
          if (!this.queryParams.productIds.includes(element.id))
            this.queryParams.productIds.push(element.id);
        });
      }
      this.showProductListDialog = !this.showProductListDialog;
    },
    getProductList() {
      this.showProductListLoading = true;
      let order = this.productPagination.descending ? "desc" : "asc";
      return productService
        .getProductList(
          this.productQueryParams,
          this.productPagination.page,
          this.productPagination.rowsPerPage,
          this.productPagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.productList = res.data.productList;
            this.productTotalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showProductListLoading = false;
        });
    },
    onSearchProduct() {
      this.productQueryParams.page = this.productPagination.page;
      this.productQueryParams.size = this.productPagination.rowsPerPage;
      this.getProductList();
    },
    toggleAllProduct() {
      if (this.selectedProductList.length) {
        this.selectedProductList = [];
      } else {
        this.selectedProductList = this.productList.slice();
      }
    },
    getProcurementPlanAssetReport() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      procurementPlanAssetReportService
        .getProcurementPlanAssetReport(
          this.queryParams,
          this.pagination.page,
          this.pagination.size,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.procurementPlanReportList =
              res.data.procurementPlanAssetReportList;
            this.totalRows = res.data.totalElements;
            this.totalPlanQty = res.data.totalPlanQty;
            this.totalPOQty = res.data.totalPOQty;
            this.totalRemainingQty = res.data.totalRemainingQty;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },

    exportAll() {
      this.buttonLoading = true;
      procurementPlanAssetReportService
        .procurementPlanAssetReportExcel(this.queryParams)
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.buttonLoading = false;
        });
    },

    closeAssetDialog(multiAssetList) {
      this.queryParams.assetIds = [];
      this.selectedAssetList = [];
      multiAssetList.forEach((asset) => {
        if (!this.queryParams.assetIds.includes(asset.id)) {
          this.queryParams.assetIds.push(asset.id);
          this.selectedAssetList.push(asset);
        }
      });
      this.showAssetDialog = !this.showAssetDialog;
    },
  },
};
</script>
